import { Input, List } from "antd";
import { useEffect, useState } from "react";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

import "./style.css";

const PlacesAutocomplete = ({
  setCenter,
  setSelected,
  selected,
  className,
  mapAddress,
}) => {
  const [addressValue, setAddresValue] = useState(mapAddress || "");

  useEffect(() => {
    if (mapAddress) {
      setAddresValue(mapAddress);
      setValue(mapAddress, false);
      !selected && setSelected(true);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapAddress]);

  const {
    setValue,
    suggestions: { data },
    clearSuggestions,
  } = usePlacesAutocomplete();

  const handleSelect = async (address) => {
    setValue(address, false);
    setAddresValue(address);
    clearSuggestions();

    const results = await getGeocode({ address });
    const { lat, lng } = await getLatLng(results[0]);

    setCenter({ lat, lng, ...(mapAddress && { addressText: address }) });
  };

  const handleClear = () => {
    setSelected(false);
    setValue("");
    setAddresValue("");
    clearSuggestions();
  };

  return (
    <div className={`places-container ${className || ""}`}>
      <div
        className={`input-container 
          ${selected ? "selected-list" : ""} ${data.length ? "has-list" : ""}`}
      >
        <Input
          type="text"
          value={addressValue}
          onChange={({ target }) => {
            !target.value && setSelected(false);
            setValue(target.value);
            setAddresValue(target.value);
          }}
          placeholder="Search an address"
        />
        {selected && (
          <img
            className="clear-image pointer"
            src="/assets/icons/close-icon.svg"
            alt="close"
            title="Clear Search"
            onClick={handleClear}
          />
        )}
      </div>
      {data.length ? (
        <List
          itemLayout="horizontal"
          className="places-list"
          size="small"
          dataSource={data}
          renderItem={(item) => (
            <List.Item
              className="places-list-item"
              onClick={() => handleSelect(item.description)}
            >
              <List.Item.Meta description={item.description} />
            </List.Item>
          )}
        />
      ) : null}
    </div>
  );
};

export default PlacesAutocomplete;
